<template>
	<div v-if="loading" class="main-content d-flex justify-content-center align-items-center" style="min-height: 100vh">
		<b-button variant="primary" style="opacity: 1" disabled>
			<div class="d-flex align-items-center gap-2">
				<b-spinner label="Loading..." class="me-2"></b-spinner>
				<span>Loading...</span>
			</div>
		</b-button>
	</div>
	<div v-else class="main-content">
		<div class="header">
			<div class="container-fluid">
				<div class="card mt-5">
					<div class="card-body">
						<div class="row row-cols-1 row-cols-md-3">
							<div class="col">
								<h2 class="mb-2">{{ $t('Dashboard') }}</h2>
								<p class="text-muted mb-md-0">
									Welcome {{ fullname }}
									{{ company_name != 'null' ? `from ${company_name}` : '' }}
								</p>
							</div>
							<div class="col"></div>
							<div class="col">
								<div class="form-group">
									<label class="form-label">Filter Department</label>
									<v-select
										v-model="body.department_id"
										:options="listDepartments"
										label="name"
										:reduce="(e) => e.id"
										name="Department"
										@input="filterPage()"
										:clearable="false"
									/>
								</div>
							</div>
							<div class="col-12 col-md-auto d-none">
								<button class="btn btn-primary lift" data-bs-toggle="modal" data-bs-target="#exampleModal">
									<span class="fe fe-folder-plus"></span>
									Report
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- CARDS -->
		<div class="container-fluid">
			<div class="header">
				<div class="row mt-5">
					<div>
						<div class="row">
							<!-- Total Contract Card -->
							<div class="col-md-4">
								<div class="card rounded h-100">
									<div class="card-body rounded text-center">
										<div class="avatar avatar-xl mx-auto">
											<div class="avatar-title rounded-circle text-primary" style="background-color: #ffe0e0">
												<span class="material-icons" style="font-size: 42px">
													<i class="fe fe-map"></i>
												</span>
											</div>
										</div>
										<div class="mt-4">
											<h4 class="text-uppercase mb-3">Total Contract</h4>
											<span class="h1 mb-0 text-danger" style="font-weight: bold; font-size: xx-large">{{ getTotalCount }}</span>
										</div>
									</div>
								</div>
							</div>

							<div class="col-md-8">
								<div class="card rounded h-100">
									<div class="card-body rounded">
										<h4 class="text-uppercase mb-4">Summary Contract {{ selectedDepartment?.name }}</h4>
										<div class="row">
											<div class="col-md-6">
												<!-- Chart.js Pie Chart -->
												<div class="chart-container">
													<canvas ref="pieChart" height="200"></canvas>
												</div>
											</div>
											<div class="col-md-6">
												<!-- Legend -->
												<div class="legend">
													<div v-for="(item, index) in displayStats" :key="index" class="legend-item mb-2 d-flex align-items-center">
														<span class="legend-color mr-2" :style="{ backgroundColor: getColor(item.status) }"></span>
														<div class="d-flex justify-content-between w-100">
															<span style="cursor: pointer" @click="goToContractList(item.status)">{{ item.status }}</span>
															<strong>{{ item.total }}</strong>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Table -->
		<div class="col-12 col-xl">
			<div class="container-fluid">
				<div class="card">
					<div class="card-header d-flex">
						<h4 class="card-header-title">List Contract</h4>
						<div class="ms-auto">
							<select v-model="selectedTable" @change="changeTable" class="form-select">
								<option value="byRemainingBudget">Contracts Use The Most Budget</option>
								<option value="byExpireSoon">Upcoming Expiring Contract</option>
								<option value="byExpiredDate">Top Expired Contract</option>
							</select>
						</div>
					</div>
					<div class="card-body p-0">
						<vue-good-table
							:line-numbers="true"
							:columns="columns"
							:rows="list[selectedTable]"
							:sort-options="{
								enabled: true,
							}"
							:total-rows="list.totalItems"
							:pagination-options="{
								enabled: false,
							}"
							@on-sort-change="onSortChange"
							style-class="vgt-table border-0 table"
						>
							<div slot="emptystate" class="text-center font-size-14">No data available</div>
							<template slot="table-row" slot-scope="props">
								<span v-if="props.column.field == 'end_date'">
									{{ formatDate(props.row.end_date) }}
								</span>
								<span v-else-if="props.column.field == 'start_date'">{{ formatDate(props.row.start_date) }}</span>
								<span v-else-if="props.column.field == 'name'">
									<div>
										<a
											:id="'contract-name-' + props.row.id"
											:href="`/listContract/${props.row.id}`"
											class="text-decoration-none text-truncate d-inline-block"
											style="max-width: 200px"
										>
											{{ props.row.name }}
										</a>
										<b-tooltip :target="'contract-name-' + props.row.id" placement="right" triggers="hover" variant="dark">
											{{ props.row.name }}
										</b-tooltip>
									</div>
								</span>
								<span v-else-if="props.column.field == 'budget'"> Rp. {{ convertNumber(props.row.budget) }} </span>
								<span v-else-if="props.column.field == 'remaining_budget'">
									Rp. {{ convertNumber(props.row.remaining_budget) }}
								</span>
							</template>
						</vue-good-table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// import tableListContract from "@/components/listContract/tableListContract.vue";
	import moment from 'moment';
	import Chart from 'chart.js/auto';
	// import { props } from "vue2-dropzone";

	export default {
		// eslint-disable-next-line vue/multi-word-component-names
		// },

		computed: {
			list() {
				return this.$store.getters['dashboard/list'];
			},
			getTotalCount() {
				// Get the total from the "Total" status, or calculate it if not available
				const totalItem = this.list.stats ? this.list.stats.find((item) => item.status === 'Total') : null;
				if (totalItem) {
					return parseInt(totalItem.total);
				}
				// Fallback: calculate from individual statuses
				return this.displayStats.reduce((sum, item) => sum + parseInt(item.total || 0), 0);
			},
			displayStats() {
				// Filter out the "Total" status and map other statuses
				if (!this.list.stats) return [];
				return this.list.stats
					.filter((item) => item.status !== 'Total')
					.map((item) => ({
						status: item.status,
						total: parseInt(item.total),
						color: this.getColor(item.status),
					}));
			},
			pieChartData() {
				const data = this.displayStats.map((item) => item.total);
				const allZero = data.every((value) => value === 0);

				return {
					labels: allZero ? ['No Data Available'] : this.displayStats.map((item) => item.status),
					datasets: [
						{
							data: allZero ? [1] : data,
							backgroundColor: allZero ? ['#061fad'] : this.displayStats.map((item) => this.getColor(item.status)),
						},
					],
				};
			},
			listDepartments() {
				const loggedUser = this.$store.getters['profile/profileData'];
				console.log('loggedUser', loggedUser);
				return loggedUser.departments;
			},
			selectedDepartment() {
				return this.listDepartments.find((item) => item.id === this.body.department_id) || null;
			},
		},
		data() {
			return {
				// test
				loading: false,
				direct: 'All',
				fullname: localStorage.getItem('fullname'),
				company_name: localStorage.getItem('company_name'),
				company_id: localStorage.getItem('company'),
				body: {
					department_id: '',
				},
				columns: [
					{
						label: 'Contract Number',
						field: 'no',
						thClass: 'table-header text-muted font-weight-bold',
						tdClass: 'color-secondary align-middle',
						width: '15%',
					},
					{
						label: 'Contract Name',
						field: 'name',
						thClass: 'table-header text-muted font-weight-bold',
						tdClass: 'color-secondary align-middle',
						width: '30%',
					},
					{
						label: 'Start Date',
						field: 'start_date',
						thClass: 'table-header text-muted font-weight-bold',
						tdClass: 'color-secondary align-middle',
						width: '10%',
					},
					{
						label: 'End Date',
						field: 'end_date',
						thClass: 'table-header text-muted font-weight-bold',
						tdClass: 'color-secondary align-middle',
						width: '10%',
					},
					{
						label: 'Value',
						field: 'budget',
						thClass: 'table-header text-muted font-weight-bold',
						tdClass: 'color-secondary align-middle',
						width: '18%',
					},
					{
						label: 'Remaining Value',
						field: 'remaining_budget',
						thClass: 'table-header text-muted font-weight-bold',
						tdClass: 'color-secondary align-middle',
						width: '45%',
					},
				],
				selectedTable: 'byRemainingBudget', // default table selected
				statusColors: {
					'On Going': '#2ECC71', // Green
					Closed: '#FF0000', // Red
					'Early Termination': '#333333', // Dark Gray/Black
					Draft: '#999999', // Darker Gray
					'Expired Soon': '#F1C40F', // Yellow
					Expired: '#FD9596', // Lighter Red
					'Value Warning': '#E67E22', // Orange
				},
				chart: null,
			};
		},
		mounted() {
			setTimeout(async () => {
				this.$Progress.start();
				this.company_id = localStorage.getItem('company');
				this.fullname = localStorage.getItem('fullname');
				this.company_name = localStorage.getItem('company_name');
				//set default department to digitech if available or first department
				if (this.body.department_id == '') {
					const digitech = this.listDepartments.find((e) => e.code == '7003.122');
					if (digitech) {
						this.body.department_id = digitech.id;
					} else {
						this.body.department_id = this.listDepartments[0]?.id;
					}
				}
				this.getListDepartment();
				this.getList();
			}, 1500);
		},
		updated() {
			if (!this.loading && this.$refs.pieChart && !this.chart) {
				this.initChart();
			}
		},
		watch: {
			// Watch for changes in displayStats to update the chart
			// displayStats: {
			// 	handler() {
			// 		this.updateChart();
			// 	},
			// 	deep: true,
			// },
		},
		methods: {
			onSortChange(param) {
				this.$emit('onSortChange', param);
			},
			sorting() {
				this.getList();
			},
			async getList() {
				this.loading = true;
				await this.$store.dispatch('dashboard/GET_LIST', this.body).finally(() => {
					this.loading = false;
					this.$Progress.finish();
					this.updateChart();
				});
			},
			changeTable() {
				// Method for handling table selection changes
			},
			formatDate(date) {
				return moment(date).format('D MMM YYYY');
			},
			convertNumber(dat) {
				if (dat == null) {
					return '-';
				} else {
					return dat.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
				}
			},
			onPageChange(payload) {
				this.body.pageSize = payload.currentPerPage;
				this.body.page = payload.currentPage;
				this.getList();
			},
			getColor(status) {
				return this.statusColors[status] || '#CCCCCC';
			},
			initChart() {
				if (this.chart) {
					this.chart.destroy();
				}

				const ctx = this.$refs.pieChart.getContext('2d');

				const data = {
					labels: this.displayStats.map((item) => item.status),
					datasets: [
						{
							data: this.displayStats.map((item) => item.total),
							backgroundColor: this.displayStats.map((item) => item.color),
							borderWidth: 3,
						},
					],
				};

				this.chart = new Chart(ctx, {
					type: 'pie',
					data: this.pieChartData,
					options: {
						responsive: true,
						maintainAspectRatio: false,
						plugins: {
							legend: {
								display: false, // Hide the built-in legend as we're using a custom one
							},
							tooltip: {
								callbacks: {
									label: function (context) {
										const label = context.label || '';
										const value = context.raw || 0;
										const total = context.chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
										const percentage = Math.round((value / total) * 100);
										return `${label}: ${value} (${percentage}%)`;
									},
								},
							},
						},
					},
				});
			},
			updateChart() {
				this.$nextTick(() => {
					this.initChart();
				});
			},
			goToContractList(status) {
				let tab = 'MyContract';
				switch (status) {
					case 'Draft':
						tab = 'draft';
						break;
					case 'On Going':
						tab = 'onGoing';
						break;
					case 'Closed':
						tab = 'closed';
						break;
					case 'Early Termination':
						tab = 'earlyTermination';
						break;
					case 'Expired Soon':
						tab = 'expiredSoon';
						break;
					case 'Expired':
						tab = 'expired';
						break;
					case 'Value Warning':
						tab = 'valueWarning';
						break;
					default:
						break;
				}
				this.$router.push({
					name: 'ListContract',
					params: { data: tab },
				});
			},
			async filterPage() {
				await this.getList();
			},
			async getListDepartment() {
				await this.$store.dispatch('profile/getProfile');
			},
		},
	};
</script>

<style scoped>
	.chart-container {
		position: relative;
		margin: auto;
		height: 200px;
		width: 100%;
	}

	.legend-color {
		display: inline-block;
		width: 16px;
		height: 16px;
		border-radius: 50%;
		margin-right: 8px;
	}

	.legend-item {
		font-size: 14px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0.5rem;
	}

	.legend-item > div {
		display: flex;
		justify-content: space-between;
		width: 100%;
		padding: 0 0.5rem;
	}
</style>
